var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"任务详情","visible":_vm.taskMsgDialogVisible,"width":"100%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.taskMsgDialogVisible=$event}}},[_c('TaskMsgCard',{attrs:{"item":_vm.item,"viewUserId":_vm.viewUserId},on:{"delItem":_vm.delItem,"doUpdateTask":_vm.doUpdateTask}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }